import { createFileRoute, Link } from '@tanstack/react-router';
import { useAuth } from '../hooks/useAuth.js';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        Lade …
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen grid place-items-center p-8">
        <div className="max-w-md text-center space-y-6">
          <h1 className="text-3xl font-bold">HireBotIQ Operations</h1>
          <p className="text-muted-foreground">
            Interne Plattform für Mitarbeiter-Onboarding, Dokumentenverwaltung
            und Compliance. Bitte melde dich an.
          </p>
          <a
            href="/api/oauth/start"
            className="inline-block px-6 py-3 rounded-lg bg-[oklch(0.7_0.04_195)] hover:bg-[oklch(0.75_0.04_195)] text-background font-medium"
          >
            Mit Authentik anmelden
          </a>
          <p className="text-xs text-muted-foreground">
            Dev-Login (lokal):{' '}
            <a className="underline" href="/api/dev/login?role=ceo">
              CEO
            </a>
            {' · '}
            <a className="underline" href="/api/dev/login?role=worker">
              Worker
            </a>
            {' · '}
            <a className="underline" href="/api/dev/login?role=client">
              Client
            </a>
          </p>
        </div>
      </div>
    );
  }

  // Authenticated landing — route based on role.
  const target =
    user.role === 'ceo' || user.role === 'internal_staff'
      ? '/admin'
      : user.role === 'worker'
        ? '/worker'
        : user.role === 'client'
          ? '/client'
          : '/pending';

  return (
    <div className="min-h-screen grid place-items-center p-8">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-semibold">Willkommen, {user.name ?? user.email}</h1>
        <p className="text-muted-foreground">
          Rolle: <span className="font-mono">{user.role}</span>
        </p>
        <Link
          to={target}
          className="inline-block px-6 py-3 rounded-lg bg-[oklch(0.7_0.04_195)] hover:bg-[oklch(0.75_0.04_195)] text-background font-medium"
        >
          Weiter
        </Link>
      </div>
    </div>
  );
}
